import { render, staticRenderFns } from "./AddMemberModal.vue?vue&type=template&id=2c30bf1c&"
import script from "./AddMemberModal.vue?vue&type=script&lang=js&"
export * from "./AddMemberModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports